<div class="grades-menu-bar">
  <nav class="grades-menu-content container">
    <c11n-tabs
      class="grades-tabs"
      [class.no-selection]="!activeTabId"
      [activeItem]="activeTabId"
      (activeItemChange)="onTabChange($event)"
      overflowOption="nav-overflow"
      variant="left-aligned">
      <ng-container *ngFor="let item of menuItems">
        <c11n-tab-panel [id]="item.tabId" [labelText]="item.labelKey ? (item.labelKey | translate) : item.label"></c11n-tab-panel>
      </ng-container>
    </c11n-tabs>
  </nav>
</div>
